var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form_item"
  }, [_c('van-field', {
    attrs: {
      "required": "",
      "label": "手机号Mobile",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form_item my_btn"
  }, [_c('van-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handelSubmit
    }
  }, [_vm._v("确认CONFIRM")])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header_img"
  }, [_c('img', {
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/a2478bade007269fc0c7236a423bd5b9.jpg"
    }
  })])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a53c0f00","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mediaCenter/findTicket.vue
// module id = null
// module chunks = 